import React, { useState, useEffect } from 'react';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import RefreshIcon from '@mui/icons-material/Refresh';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

const RefreshPortfolioTable = ({ refreshPortfolio, toggleHideNumbers, hideNumbers }) => {
  const [lastRefreshed, setLastRefreshed] = useState(null);

  useEffect(() => {
    const storedLastRefreshed = localStorage.getItem('lastRefreshed');
    if (storedLastRefreshed) {
      setLastRefreshed(new Date(parseInt(storedLastRefreshed, 10)));
    }
  }, []);

  const handleRefresh = () => {
    refreshPortfolio();
    const now = new Date();
    setLastRefreshed(now);
    localStorage.setItem('lastRefreshed', now.getTime());
  };

  const getTimeSinceLastRefreshed = () => {
    if (!lastRefreshed) return 'Never';
    const now = new Date();
    const diff = Math.floor((now - lastRefreshed) / 1000); // Difference in seconds
    if (diff < 60) return `${diff} seconds ago`;
    if (diff < 3600) return `${Math.floor(diff / 60)} minutes ago`;
    if (diff < 86400) return `${Math.floor(diff / 3600)} hours ago`;
    return `${Math.floor(diff / 86400)} days ago`;
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <Tooltip title="Refresh the portfolio data manually if it does not load or display correctly.">
        <IconButton onClick={handleRefresh} className="refresh-icon-button">
          <RefreshIcon className="refresh-icon" />
        </IconButton>
      </Tooltip>
      <Typography variant="body2" style={{ marginLeft: '8px' }}>
        Last refreshed: {getTimeSinceLastRefreshed()}
      </Typography>
    
    </div>
  );
};

export default RefreshPortfolioTable;
